import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  Grid,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";

import useAuth from "../../hooks/useAuth";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

function ResetPassword() {
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  return (
    <Formik
      initialValues={{
        phoneNumber: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        phoneNumber: Yup.string().max(255).required("Số điện thoại bắt buộc"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          resetPassword(values.phoneNumber);
          navigate("/auth/otp");
        } catch (error: any) {
          const message = error.message || "Đã xảy ra sự cố";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>

          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                type="phoneNumber"
                name="phoneNumber"
                label="số điện thoại"
                value={values.phoneNumber}
                error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                fullWidth
                helperText={touched.phoneNumber && errors.phoneNumber}
                onBlur={handleBlur}
                onChange={handleChange}
                my={3}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                size="small"
              >
                Gửi mã OTP
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="primary"
                size="small"
                onClick={() => navigate("/auth/sign-in")}
              >
                Quay lại đăng nhập
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}

export default ResetPassword;
